export type SearchOption = {
    label: string;
    Abbreviation?: string;
    weight?: number;
};

export const searchAndSortOptions = <T extends SearchOption>(input: string, options: T[]): T[] => {
    if (!input) {
        return [];
    }
    // Filter lenders based on the input or abbreviation so weight calculation can run on smaller data set
    const filterData = options.filter(
        (option) =>
            option.label.toLowerCase().includes(input.toLowerCase()) ||
            ('Abbreviation' in option && option.Abbreviation?.toLowerCase().includes(input.toLowerCase()))
    );

    // Calculate weight for each option, with a lower weight for better matches
    const weightedFilterData = filterData.map((option: T) => {
        // Normalize input to lowercase for case-insensitive comparison
        const inputLower = input.toLowerCase();
        const labelLower = option.label.toLowerCase();
        // Abbreviation match with weight -1
        if (option.Abbreviation?.toLowerCase().includes(inputLower)) {
            return { ...option, weight: -1 };
        }
        const inputWords = inputLower.split(/\s+/);
        const labelWords = labelLower.split(/\s+/);

        let bestMatchIndex = Infinity; // Initialize with a high value

        // Iterate through each word in the input
        for (const inputWord of inputWords) {
            // Find the index of the first matching word in the label
            const wordIndex = labelWords.findIndex((labelWord) => labelWord.startsWith(inputWord));

            if (wordIndex !== -1 && wordIndex < bestMatchIndex) {
                bestMatchIndex = wordIndex;
            }
        }

        // Assign weight based on the best match
        const weight = bestMatchIndex === Infinity ? 100 : bestMatchIndex;

        return { ...option, weight: weight };
    });

    // Sort by weight, ascending order
    const sortedFilterData = weightedFilterData.sort((a, b) => {
        if (a.weight === b.weight) {
            return a.label.localeCompare(b.label);
        }
        return a.weight - b.weight;
    });

    return sortedFilterData;
};
